module.exports = ".no-leido td{\r\n    background:#fffa8e;\r\n}\r\n\r\n#checkEnviado{\r\n    color: mediumseagreen;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/mensajes/mensajes.component.css
// module id = ./src/app/components/mensajes/mensajes.component.css
// module chunks = main